import { cardApi } from "@/core/data/api";

export default async (info, query) => {
  return await cardApi.createCards(info, query);
};
